import styled from "styled-components"

const titleHeight = 36
const buttonHeight = 44
const deleteWrapperWidth = 40
export const sumHeight = titleHeight + buttonHeight

export type Size = "sm" | "lg"

const defineHeight = (size: Size) => (size === "sm" ? titleHeight : sumHeight)

export const FileLoaderWrapper = styled.div<{
    size: Size
    disabled: boolean
}>`
    display: flex;
    align-items: center;
    position: relative;
    width: 100%;
    max-width: 500px;
    height: ${(props) => defineHeight(props.size)}px;
    margin-bottom: 8px;
    border: 1px solid ${(props) => props.theme.fileLoaderBorderColor};
    border-radius: 2px;
    overflow: hidden;
    pointer-events: ${(props) => (props.disabled ? "none" : "all")};
`
export const FileLogoWrapper = styled.div<{
    size: Size
}>`
    width: ${(props) => defineHeight(props.size)}px;
    height: ${(props) => defineHeight(props.size)}px;
    border-right: 1px solid ${(props) => props.theme.fileLoaderBorderColor};
    display: flex;
    align-items: center;
    justify-content: center;
`
export const FileLoaderBodyWrapper = styled.div<{
    size: Size
}>`
    height: ${(props) => defineHeight(props.size)}px;
    width: calc(100% - ${(props) => defineHeight(props.size)}px - ${deleteWrapperWidth}px);
 `
export const FileDeleteWrapper = styled.div<{
    disabled: boolean
}>`
    width: ${deleteWrapperWidth}px;
    height: 100%;
    border-left: 1px solid ${(props) => props.theme.fileLoaderBorderColor};
    background: ${(props) => props.theme.fileLoaderButtonBackground};
    opacity: ${(props) => (props.disabled ? 0.7 : 1)};
    pointer-events: ${(props) => (props.disabled ? "none" : "all")};

    &:hover {
        background: ${(props) => props.theme.fileLoaderButtonHoverBackground};
        transition: 0.1s ease;
    }

    & > div { // style for delete button
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
    }
`
export const FileTitleWrapper = styled.div`
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: ${titleHeight}px;
    width: 100%;
    color: ${(props) => props.theme.fileLoaderTitleColor};
`
export const FileTitle = styled.span`
    max-width: calc(100% - 100px);
    height: fit-content;
    margin: 0 10px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    border-bottom: 1px dashed transparent;
    transition: 0.1s ease;
`
export const FileSize = styled.span`
    width: 100px;
    height: fit-content;
    margin: 0 10px;
    text-align: center;
`
export const FileInput = styled.input`
    position: absolute;
    width: calc(100% - 100px);
    height: 100%;
    top: 0;
    left: 0;
    opacity: 0;

    &:hover + ${FileTitle} {
        color: ${(props) => props.theme.fileLoaderTitleHoverColor};
        border-bottom-color: ${(props) => props.theme.fileLoaderTitleHoverColor};
        transition: 0.1s ease;
    }
`
export const FileButton = styled.div<{
    width: number
    disabled?: boolean
}>`
    display: flex;
    height: 100%;
    width: ${(props) => props.width}%;
    align-items: center;
    justify-content: center;
    color: ${(props) => props.theme.fileLoaderButtonColor};
    background: ${(props) => props.theme.fileLoaderButtonBackground};
    border-top: 1px solid;
    border-left: 1px solid;
    border-color: ${(props) => props.theme.fileLoaderBorderColor};
    cursor: pointer;
    opacity: ${(props) => (props.disabled ? 0.7 : 1)};
    pointer-events: ${(props) => (props.disabled ? "none" : "all")};

    &:hover {
        color: ${(props) => props.theme.fileLoaderButtonHoverColor};
        background: ${(props) => props.theme.fileLoaderButtonHoverBackground};
        transition: 0.1s ease;
    }

    & > span { // style for storage icon
        margin: 0 10px;
    }
`
export const FileButtonWrapper = styled.div`
    display: flex;
    height: ${buttonHeight}px;
    width: 100%;

    & > ${FileButton} {
        &:first-child {
            border-left: 0;
        }
    }
`
export const DownloadLink = styled.a`
`
